window['ThemeTile'] = (link, title, mediaCount) => {
  return {
    hover: false,
    link: link,
    title: title,
    totalImages: mediaCount || 1,
    flickity: null,
    resizeObserver: null,

    init() {
      if (this.totalImages > 1 && window.innerWidth < 1024) {
        this.initFlickity();
      }
    },

    initFlickity() {
      const carousel = this.$refs.flickityCarousel;
      if (!carousel || typeof Flickity === 'undefined') return;

      this.flickity = new Flickity(carousel, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        draggable: true,
        wrapAround: false,
        freeScroll: false,
        friction: 0.8,
        selectedAttraction: 0.2,
        dragThreshold: 15,
        on: {
          staticClick: (event, pointer, cellElement, cellIndex) => {
            if (cellIndex !== undefined) {
              window.location.href = this.link;
            }
          }
        }
      });

      // Watch the tile element for width changes (e.g. 2→3 column toggle)
      // and call flickity.resize() so cells are never cropped
      let lastWidth = this.$el.offsetWidth;
      this.resizeObserver = new ResizeObserver(() => {
        const newWidth = this.$el.offsetWidth;
        if (newWidth !== lastWidth) {
          lastWidth = newWidth;
          this.flickity.resize();
        }
      });
      this.resizeObserver.observe(this.$el);
    },

    destroy() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      if (this.flickity) {
        this.flickity.destroy();
        this.flickity = null;
      }
    },

    showLabel() {
      if (this.$refs.labelContent) {
        this.labelContent = this.$refs.labelContent.innerHTML;
        this.focusVisible = this.$refs.tileLink && this.$refs.tileLink.matches(':focus-visible');
      }
    },
    hideLabel() {
      this.labelContent = '';
      this.focusVisible = false;
    },
    async openQuickView() {
      this.$store.quickview.render(link);
      this.$store.modals.open('productQuickView');
    },
  };
};
